import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../../components/Layout";
import ExercisesContent from "../../../components/Pages/Middot/Edit";

const { displayName } = config;

export default function MiddotEdit(): React.ReactNode | null {
  useEffect(() => {
    document.title = `${displayName}: Middot edit`;
  }, []);

  return (
    <Layout>
      <ExercisesContent />
    </Layout>
  );
}
